import { noop, TextInput, TextInputProps } from "@mantine/core"
import { IconSearch } from "@tabler/icons-react"

import { useDebounceWithCallback } from "../../hooks/useDebounceWithCallback"

type SearchInputProps = {
  delay?: number | undefined
  inputValue: string
  onChange: (value: string) => void
  label?: React.ReactNode
  labelProps?: TextInputProps
  searchIconSize?: string | number
  clearIconSize?: number

  onOpen?: () => void
} & Omit<TextInputProps, "onChange">

export const SearchInput = ({
  delay = 200,
  inputValue,
  onChange,
  onOpen = noop,
  label,
  labelProps,
  searchIconSize = "1rem",
  ...props
}: SearchInputProps) => {
  const [searchText, handleChange] = useDebounceWithCallback(
    inputValue,
    (newValue) => {
      onChange(newValue)
      onOpen()
    },
    delay
  )

  return (
    <TextInput
      labelProps={labelProps}
      label={label}
      value={searchText}
      onChange={(e) => handleChange(e.target.value)}
      leftSection={
        <IconSearch
          size={searchIconSize}
          style={{ cursor: searchText ? "pointer" : "default" }}
        />
      }
      {...props}
    />
  )
}
